import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import Axios from "../apis/axios";
import { NodeId } from "components/NodeId";
import { produce } from "immer";

class Deferred {
  promise: Promise<any>;
  resolve!: (value?: any) => void;
  reject!: (reason?: any) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}

const createMaintenanceSlice = (set: (data: any) => void, get: () => any) => ({
  getBackups: {},

  createMaintenance: (payload: any) => {
    if (payload.workflownodeid === undefined) {
      payload.workflownodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
    }

    if (payload.workflowstepnodeid === "") {
      payload.workflowstepnodeid = new NodeId(
        "mesutronic.de",
        uuidv4()
      ).toUrl();
    }

    if (payload.nodeid === undefined) {
      payload.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
    }

    const commandObjects = [];
    const attachmentCommandObjects = [];
    if (payload.attachments?.length > 0) {
      for (const item of payload.attachments) {
        if (item.attachment.nodeid) {
          delete item.attachment.nodeid;
        }

        const attachment = item.attachment;
        if (attachment.nodeid === undefined || attachment.nodeid === null) {
          attachment.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
        }

        const attachmentPayload = {
          isattachmentof: payload.workflowstepnodeid,
          lang: payload.lang,
          nodeid: attachment.nodeid,
          file: attachment.file,
          title: attachment.title,
          description: attachment.description,
          specifier: "",
        };
        const fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        const attachmentCommandObject = {
          parentNodeIds: [payload.workflowstepnodeid],
          nodeId: attachment.nodeid,
          payload: attachmentPayload,
          filesToUpload: [fileToUpload],
          type: "create",
          task: "processCreateAttachmentCommand",
        };
        attachmentCommandObjects.push(attachmentCommandObject);
      }
    }

    delete payload.attachments;
    const maintenanceCommandObject = {
      parentNodeIds: [payload.equipmentnodeid],
      nodeId: payload.nodeid,
      payload: payload,
      type: "create",
      task: "processCreateMaintenanceCommand",
    };
    commandObjects.push(maintenanceCommandObject, ...attachmentCommandObjects);

    const promises = get().enqueueCommands(commandObjects);


    return promises;
  },

  updateMaintenance: (payload: any) => {
    if (payload.nodeid === undefined) {
      payload.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
    }

    const commandObjects = [];
    const attachmentCommandObjects = [];

    if (payload.attachments?.length > 0) {
      for (const item of payload.attachments) {
        if (item.attachment.nodeid) {
          delete item.attachment.nodeid;
        }

        const attachment = item.attachment;
        if (attachment.nodeid === undefined || attachment.nodeid === null) {
          attachment.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
        }

        const attachmentPayload = {
          isattachmentof: payload.workflowstepnodeid,
          lang: payload.lang,
          nodeid: attachment.nodeid,
          file: attachment.file,
          title: attachment.title,
          description: attachment.description,
          specifier: "",
        };
        const fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        const attachmentCommandObject = {
          parentNodeIds: [payload.workflowstepnodeid],
          nodeId: attachment.nodeid,
          payload: attachmentPayload,
          filesToUpload: [fileToUpload],
          type: "create",
          task: "processCreateAttachmentCommand",
        };
        attachmentCommandObjects.push(attachmentCommandObject);
      }
    }

    delete payload.attachments;
    const maintenanceCommandObject = {
      parentNodeIds: [payload.equipmentnodeid],
      nodeId: payload.nodeid,
      payload: payload,
      type: "update",
      task: "processUpdateMaintenanceCommand",
    };
    commandObjects.push(...attachmentCommandObjects, maintenanceCommandObject);

    const promises = get().enqueueCommands(commandObjects);


    return promises;
  },

  processUpdateMaintenanceCommand: async (commandObject: any) => {
    try {
      if (get().isLoggedIn === true) {
        const encodedMaintenanceTaskNodeid = encodeURIComponent(
          commandObject.payload.maintenancetasknodeid
        );

        const response = await Axios.put(
          "/api/v1/maintenancetasks/" + encodedMaintenanceTaskNodeid,
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const a = 10;

        if (response && response?.status == 200) {
         
          return response.data;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
    
      throw new Error(error as string);
    }
  },

  processCreateMaintenanceCommand: async (commandObject: any) => {
    try {
      if (get().isLoggedIn === true) {
        const response = await Axios.post(
          "api/v1/maintenancetasks",
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const a = 10;

        if (response && response?.status == 200) {
        
          return response.data;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      
      throw new Error(error as string);
    }
  },
  getAllMaintenanceCategories: async () => {
    try {
      if (get().isLoggedIn === true) {
        const response = await Axios.get(`api/v1/maintenancecategories?lang=${get().lang}`, {
          headers: {
            "Content-Type": "application/json",
           
          },
        });

        if (response && response?.status == 200) {
          set(
            produce((state: any) => {
              //update in notificationDetails
              state.maintenanceCategories = response.data;
            })
          );
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
     
      throw new Error(error as string);
    }
  },

  deleteMaintenanceTask: async (
    //added additional parameter "equipmentNodeId" because of faq , workFlow etc , we need it for which equipment this faq belong to so that we can take that equipment and edit its faq
    maintenancetasknodeid: string,
    equipmentnodeid: string
  ) => {
    let promises;
    const payload: any = {};
    payload.nodeid = maintenancetasknodeid;
    payload.equipmentnodeid = equipmentnodeid;
    const deleteCommandObject = {
      parentNodeIds: [equipmentnodeid],
      nodeId: maintenancetasknodeid,
      payload: payload,
      type: "delete",
      task: "processDeleteMaintenanceTaskCommand",
    };
    promises = get().enqueueCommands([deleteCommandObject]);

    //the command was not yet sent to the server
    const promise = new Deferred();
    promise.resolve();
    promises = [promise];

    return promises;
  },

  processDeleteMaintenanceTaskCommand: async (commandObject: any) => {
    try {
     

      if (get().isLoggedIn === true) {
        const encodedMaintenanceTaskNodeid = encodeURIComponent(
          commandObject.payload.nodeid
        );

        const response = await Axios.delete(
          "/api/v1/maintenancetasks/" + encodedMaintenanceTaskNodeid,
          {
            data: commandObject.payload, // Include payload here

            headers: {
              "Content-Type": "application/json",
              
            },
            timeout: 10000,
          }
        );

        if (response && response?.status == 200) {
         
          return;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },
});

export default createMaintenanceSlice;
